export default __webpack_public_path__ + "static/image2-1ac59cfacd17148066062f47fd6fdbdd.jpg";